<template>
  <div id="divSummary">
    <div class="Flex_Table tblEntryForm">
      <div class="Flex_Row">
        <div class="Flex_Cell">
          <fieldset class style="width: 100% !important">
            <legend>Update Password</legend>
            <div class="Flex_Table tblEntryForm">
              <div class="Flex_Row" align="left" valign="middle">
                <div class="Flex_Cell">
                  <span class="mandatorySpan" :class="{ Required: true }">Old Password</span>
                  <AcceptInput
                    maxlength="112"
                    ref="userOldPass"
                    type="password"
                    :isRequired="true"
                    placeholder="PLEASE ENTER YOUR OLD PASSWORD"
                    v-model="userOldPass"
                    class="CreateAccount"
                    autocomplete="off"
                    readonly
                    onfocus="this.removeAttribute('readonly');"
                  />
                </div>
                <div class="Flex_Cell">
                  <span class="mandatorySpan" :class="{ Required: true }">New Password</span>
                  <AcceptInput
                    maxlength="112"
                    ref="userPass"
                    type="password"
                    :isRequired="true"
                    placeholder="PLEASE ENTER YOUR NEW PASSWORD"
                    v-model="userPass"
                    class="CreateAccount"
                    @keyup="checkPasswordStrength($event)"
                    autocomplete="off"
                    readonly
                    onfocus="this.removeAttribute('readonly');"
                  />
                </div>
                <div class="Flex_Cell">
                  <span class="mandatorySpan" :class="{ Required: true }">Confirm Password</span>
                  <AcceptInput
                    maxlength="112"
                    ref="confirmPass"
                    type="password"
                    :isRequired="true"
                    placeholder="PLEASE CONFIRM YOUR PASSWORD"
                    v-model="confirmPass"
                    class="CreateAccount"
                    autocomplete="off"
                    @keyup="confirmPassword($event)"
                    readonly
                    onfocus="this.removeAttribute('readonly');"
                  />
                </div>
                <div class="Flex_Cell"></div>
                <div class="Flex_Cell"></div>
                <div class="Flex_Cell"></div>
                <div class="Flex_Cell"></div>
                <div class="Flex_Cell"></div>
              </div>
              <div class="Flex_Row" align="left" valign="middle">
                <div class="Flex_Cell" style="width: 100% !important">
                  <input
                    type="button"
                    value="Change Password"
                    style="padding: 10px"
                    title="Click here to Save Password"
                    @click="showMessageBox()"
                  />
                  <!-- <input
                    type="button"
                    value="Clear"
                    style="padding: 10px"
                    title="Click here to Clear"
                    @click="reset()"
                  />-->
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import ChangePasswordJS from "./servicesJS/ChangePassword.js";
import LoginJS from "./servicesJS/Login.js";
import CryptoJS from "crypto-js";
import AcceptInput from "./ekkControls/AcceptInput";
import DateControl from "./ekkControls/DateControl";
import biometricJS from "../router/biometric";

export default {
  name: "ChangePassword",
  components: {
    DateControl: DateControl,
    AcceptInput: AcceptInput
  },
  data() {
    return {
      userOldPass: "",
      userPass: "",
      confirmPass: "",
      userTypeID: -1,
      currentUser: {
        userName: "",
        lastLoginAttempt: "",
        userRights: [],
        connection: null
      },
      masterData: {
        IsMenuOpen: true,
        PageThme: "AAADTheme",
        FormID: -1,
        FormName: "Home",
        FormDisplayName: "Home",
        FooterMessage: "Best Viewed in Chrome / Firefox",
        moduleID: -1
      },
      k: "8080808080808080",
      s: 16
    };
  },
  methods: {
    reset() {
      this.userPass = "";
      this.userOldPass = "";
      this.confirmPass = "";
      var lblPasswordStreingth = document.getElementById(
        "lblPasswordStreingth"
      );
      lblPasswordStreingth.innerHTML = "";
      lblPasswordStreingth.style.border = "";
      lblPasswordStreingth.style.color = "";
      var lblConfirmPassword = document.getElementById("lblConfirmPassword");
      lblConfirmPassword.innerHTML = "";
      lblConfirmPassword.style.border = "";
      lblConfirmPassword.style.color = "";
    },
    showMessageBox() {
      if (this.checkPrams(this.userOldPass) == true) {
        MessageBox.show({
          message: "Please Type Old Password",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.checkPrams(this.userPass) == true) {
        MessageBox.show({
          message: "Please Type Password",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.checkPrams(this.confirmPass) == true) {
        MessageBox.show({
          message: "Please Type Confirm Password",
          type: "error",
          title: "Error"
        });
        return;
      }
      // if (this.userPass.length < 8) {
      //   MessageBox.show({
      //     message: "Password Length Must Be 8 Characters Long.",
      //     type: "error",
      //     title: "Error"
      //   });
      //   return;
      // }
      if (this.userPass != this.confirmPass) {
        MessageBox.show({
          message: "Confirm Password should be same as New Password",
          type: "error",
          title: "Error"
        });
        return;
      }
      // if (!this.isPasswordStrenth) {
      //   MessageBox.show({
      //     message:
      //       "Weak password! Password Length Must Be 8 Characters Long.Password Must Have : 1 Digit, 1 Lower Character,1 Upper Character and 1 Special Character.",
      //     type: "error",
      //     title: "Error"
      //   });
      //   return;
      // }
      MessageBox.show(
        {
          message: "Do you want to change Password?",
          type: "confirm",
          title: "",
          defaultButton: 2
        },
        { buttonName: "Yes", buttonAction: this.updateUserPassword },
        { buttonName: "No", buttonAction: this.reset }
      );
    },
    updateUserPassword() {
      var MatchValue = biometricJS.encryptAES(
        this.userOldPass + "|~|" + this.userPass
      );
      let pwd = biometricJS.computeHash(this.userPass);
      var basicData = {
        MatchValue: MatchValue,
        UserPassword: pwd,
        ConfirmPass: pwd,
        Type: 1
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      ChangePasswordJS.updateUserPassword(formData).then(
        response => {
          var msg = response.data.msg;
          var isSuccess = response.data.isSuccess;
          if (isSuccess) {
            this.userPass = "";
            // var lblPasswordStreingth = document.getElementById(
            //   "lblPasswordStreingth"
            // );
            // lblPasswordStreingth.innerHTML = "";
            // lblPasswordStreingth.style.border = "";
            // lblPasswordStreingth.style.color = "";
            // this.confirmPass = "";
            // var lblConfirmPassword =
            //   document.getElementById("lblConfirmPassword");
            // lblConfirmPassword.innerHTML = "";
            // lblConfirmPassword.style.border = "";
            // lblConfirmPassword.style.color = "";
            MessageBox.show({
              message:
                "Password has been changed, Now login with the new Password",
              type: "success",
              title: "Success"
            });
            this.LogOut();
          } else {
            MessageBox.show({
              message: msg,
              type: "error",
              title: "Error"
            });
          }
        },
        error => {}
      );
    },
    LogOut() {
      LoginJS.Logout().then(
        response => {
          if (this.connection != null) {
            this.connection.stop();
          }
          window.sessionStorage.clear();
          //this.NevigateForm("Login");
          this.$router.go("Login");
        },
        error => {
          if (this.connection != null) {
            this.connection.stop();
          }
          window.sessionStorage.clear();
          this.NevigateForm("Login");
        },
        failure => {}
      );
    },
    NevigateForm(objRoute) {
      if (objRoute.split("/").length > 1) {
        objRoute = objRoute.split("/")[0];
      }
      this.$router.push({ name: objRoute });
      this.masterData.IsMenuOpen = false;
    },
    checkPrams(_param) {
      var _isError = false;
      if (_param == "" || _param == -1 || _param == null || _param == 0) {
        _isError = true;
      }
      if (_isError) {
        return _isError;
      }
    },
    checkPasswordStrength(element) {
      this.isPasswordStrenth = false;
      var obj = element.currentTarget;
      var pass = obj.value;
      var lblPasswordStreingth = document.getElementById(
        "lblPasswordStreingth"
      );

      if (lblPasswordStreingth == null) {
        lblPasswordStreingth = document.createElement("div");
        lblPasswordStreingth.id = "lblPasswordStreingth";
        lblPasswordStreingth.style.backgroundColor = "white";
        lblPasswordStreingth.style.fontWeight = "bold";
        lblPasswordStreingth.style.padding = "5px";
        lblPasswordStreingth.style.position = "sticky";
        lblPasswordStreingth.style.left = "350px";
        lblPasswordStreingth.style.whiteSpace = "wrap";
        obj.parentNode.style.position = "relative";
        $(obj).after(lblPasswordStreingth);
      }
      lblPasswordStreingth.style.color = "Red";
      lblPasswordStreingth.style.border = "solid 1px red";
      var msg;
      if (pass.length < 8) {
        msg =
          "Password Length Must Be 8 Characters Long.<br>Password Must Have : 1 Digit, 1 Lower Character,<br>1 Upper Character and 1 Special Character.";
        lblPasswordStreingth.innerHTML = msg;
      } else if (pass.length == 0) {
        lblPasswordStreingth.innerHTML = "";
        lblPasswordStreingth.style.border = "";
        lblPasswordStreingth.style.color = "";
        this.isPasswordStrenth = false;
      } else {
        var variations = {
          digits: /\d/.test(pass),
          lower: /[a-z]/.test(pass),
          upper: /[A-Z]/.test(pass),
          nonWords: /\W/.test(pass)
        };
        msg = "Password Must Have : ";
        if (variations.digits == false) {
          msg += "1 Digit,";
        }
        if (variations.lower == false) {
          msg += "1 Lower Character,";
        }
        if (variations.upper == false) {
          msg += "1 Upper Character,";
        }
        if (variations.nonWords == false) {
          msg += "1 Special Character,";
        }
        lblPasswordStreingth.innerHTML = msg;
        if (
          variations.digits &&
          variations.lower &&
          variations.upper &&
          variations.nonWords
        ) {
          lblPasswordStreingth.innerHTML = "You Have Entered Strong Password";
          lblPasswordStreingth.style.border = "solid 1px green";
          lblPasswordStreingth.style.color = "green";
          this.isPasswordStrenth = true;
        }
      }
    },
    confirmPassword(element) {
      var obj = element.currentTarget;
      var confPass = obj.value;
      var lblConfirmPassword = document.getElementById("lblConfirmPassword");
      if (lblConfirmPassword == null) {
        lblConfirmPassword = document.createElement("div");
        lblConfirmPassword.id = "lblConfirmPassword";
        lblConfirmPassword.style.backgroundColor = "white";
        lblConfirmPassword.style.fontWeight = "bold";
        lblConfirmPassword.style.padding = "5px";
        lblConfirmPassword.style.position = "sticky";
        lblConfirmPassword.style.left = "350px";
        lblConfirmPassword.style.whiteSpace = "wrap";
        obj.parentNode.style.position = "relative";
        $(obj).after(lblConfirmPassword);
      }
      var msg;
      if (confPass.length > 0) {
        if (confPass != this.userPass) {
          msg = "Confirm Password should be same as New Password";
          lblConfirmPassword.style.color = "Red";
          lblConfirmPassword.style.border = "solid 1px red";
          lblConfirmPassword.innerHTML = msg;
        } else if (confPass == this.userPass) {
          lblConfirmPassword.innerHTML = "Password matched";
          lblConfirmPassword.style.border = "solid 1px green";
          lblConfirmPassword.style.color = "green";
        }
      } else if (confPass.length == 0) {
        lblConfirmPassword.innerHTML = "";
        lblConfirmPassword.style.border = "";
        lblConfirmPassword.style.color = "";
      } else {
        lblConfirmPassword.innerHTML = "";
        lblConfirmPassword.style.border = "";
        lblConfirmPassword.style.color = "";
      }
    }
  },
  mounted() {}
};
</script>

<style scoped>
.wrapText {
  overflow: anywhere;
}
fieldset {
  margin-bottom: 4px !important;
}
fieldset > div {
  overflow: hidden;
}
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: medium;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divUserProfile {
  margin-left: 4px;
  margin-right: 5px;
  /* border: dotted 1px darkgray;
  border-radius: 5px;
  padding: 5px 0px 5px 5px; */
}
.rblGender input[type="radio"] {
  position: fixed;
  width: 0;
  cursor: pointer;
  opacity: 0.55;
}
.rblDiv {
  display: inline;
  margin-right: 5%;
}
</style>
<style scoped>


// WEBPACK FOOTER //
// src/components/ChangePassword.vue